/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Link } from 'react-router';
import { HelpBlock } from 'react-bootstrap';
import format from 'date-fns/format';
import LineChart from 'loracoms/LineChart';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';

const kFormat = { en: 'DD/MM/YYYY HH:mm:ss', zh: 'YYYY-MM-DD HH:mm:ss' };
const propTypes = {
  intl: intlShape.isRequired,
  adr: PropTypes.object.isRequired,
};
const kSeries = {
  smoth: true,
  symbolSize: 0,
  areaStyle: {
    normal: {
      opacity: 0,
    },
  },
};

const kDR = { symbolSize: 10, yAxisIndex: 1, showAllSymbol: true };
const formatNum = (n = 0) => Number(n.toFixed(2));

class DynamicChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adr: props.adr,
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.adrview.marginrate');
  }

  componentWillReceiveProps(nextProps) {
    const { adr } = nextProps;
    if (!_.isEqual(adr, this.props.adr)) {
      this.setState({ adr });
    }
  }

  render() {
    const { adr: { disabled, history, current, margin = 0 }, view = 'DR' } = this.state;
    const { locale } = this.props.intl;
    const categories = [];
    const range = [];
    const drLine = [];
    const power = [];
    const marginLine = [];
    const target = [];
    _.forEach(history, (h) => {
      categories.push(format(h.timestamp, kFormat[locale]));
      range.push((formatNum(h.range) + formatNum(h.target)).toFixed(2));
      drLine.push(formatNum(h.dr));
      power.push(formatNum(h.power));
      marginLine.push(formatNum(h.margin));
      target.push(formatNum(h.target));
    });
    categories.push(this.intlMsg.msg('latest'));
    range.push(formatNum(target[target.length - 1] + current.range));
    drLine.push(formatNum(current.dr));
    power.push(formatNum(current.power));
    marginLine.push(formatNum(current.margin));
    target.push(formatNum(margin || target[target.length - 1]));

    if (!history.length && disabled) {
      return <div className={styles.noData}>{this.intlMsg.msg('nodata')}</div>;
    }

    if (!history.length && !disabled) {
      return <div className={styles.noData}>{this.intlMsg.msg('start')}</div>;
    }

    const series = [
      { ...kSeries, name: 'Real', data: marginLine },
      { ...kSeries, name: 'High', data: range, areaStyle: { normal: { opacity: 0.2 } } },
      { ...kSeries, name: 'Low', data: target, areaStyle: { normal: { opacity: 0.2 } } },
    ];
    const legend = { top: 30, data: ['Real', 'High', 'Low'] };
    if (view === 'DR') {
      series.push({ ...kSeries, ...kDR, name: 'DR', data: drLine });
      legend.data.push('DR');
    } else {
      series.push({ ...kSeries, ...kDR, name: 'Power', data: power });
      legend.data.push('Power');
    }
    return (
      <div className={styles.container}>
        <Link
          className={styles.switcher}
          onClick={() => this.setState({ view: view === 'DR' ? 'Power' : 'DR' })}
        >
          <i className="fa fa-hand-o-right" />&nbsp;{view === 'DR' ? 'Power' : 'DR'}
        </Link>
        <LineChart
          title={{
            text: this.intlMsg.msg('title'),
            left: 'center',
            textStyle: { fontWeight: 300, fontSize: 14 },
          }}
          categories={categories}
          series={series}
          legend={legend}
          colors={['#36d7b7', '#85d4e3', '#f22400', '#e3d200', '#e3d200']}
          yAxis={[
            { type: 'value', name: 'Margin (dB)', min: 0, max: 40 },
            {
              type: 'value',
              name: view,
              min: 0,
              max: _.max(_.concat(view === 'DR' ? drLine : power, [5])),
            },
          ]}
        />
        <HelpBlock className="aisz-help-block">
          <i className="fa fa-info-circle" />&nbsp;
          Real: {this.intlMsg.msg('real')}
        </HelpBlock>
        <HelpBlock className="aisz-help-block">
          <i className="fa fa-info-circle" />&nbsp;
          [ Low, High ]: {this.intlMsg.msg('range')}
        </HelpBlock>
      </div>
    );
  }
}

DynamicChart.propTypes = propTypes;

export default injectIntl(DynamicChart);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/ADRView/DynamicChart/index.jsx